import React from 'react';
import c from 'classnames';
import SimpleTooltip from '../../tooltips/dsPreset/SimpleTooltip';
import ThumbStatusIndicator from '../ThumbStatusIndicator/ThumbStatusIndicator';
import s from './ThumbStatusIndicators.scss';
const ThumbStatusIndicators = ({ className , indicators  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, indicators.map(({ type , tooltip  })=>/*#__PURE__*/ React.createElement(SimpleTooltip, {
            key: type,
            text: tooltip,
            usePortal: true
        }, /*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            key: type,
            type: type,
            size: "medium"
        }))));
};
ThumbStatusIndicators.displayName = 'ThumbStatusIndicators';
export default ThumbStatusIndicators;
